import type { AxiosResponse } from 'axios'
import type { NotificationOptions } from 'element-plus'
import type { LoginContext } from '@/compositions/gaUtils'
import type { Token } from '@/stores/game'
import * as Sentry from '@sentry/vue'
import { useDocumentVisibility } from '@vueuse/core'
import axios, { AxiosError } from 'axios'
import { ElNotification } from 'element-plus'
import pkgLodash from 'lodash'
import connectTipCookingWarsUrl_1 from '@/assets/games/cooking/connectInImg-1.webp'
import connectTipCookingWarsUrl_2 from '@/assets/games/cooking/connectInImg-2.webp'
import energyIconCookingWarsUrl from '@/assets/games/cooking/energyUrl.png'
import freeIconCookingWarsUrl from '@/assets/games/cooking/freeIcon.webp'
import freeIconUpCookingWarsUrl from '@/assets/games/cooking/freeIconUp.webp'
import gameBannerCookingWarsUrl from '@/assets/games/cooking/gameBanner.webp?url'
import gemFirstBuyCookingWarsUrl from '@/assets/games/cooking/gemFirstBuyBgImg.webp?url'
import iconCookingWarsUrl from '@/assets/games/cooking/icon.jpg?url'
import logInBannerBgCookingWarsUrl from '@/assets/games/cooking/logInBannerBg.jpg?url'
import logInBannerIconCookingWarsUrl from '@/assets/games/cooking/logInBannerIcon.png?url'
import logInCookingWarsUrl_1 from '@/assets/games/cooking/logInImg-1.jpg?url'
import logoCookingWarsUrl from '@/assets/games/cooking/logo.png?url'
import loyaltyIconCookingWarsUrl from '@/assets/games/cooking/loyaltyIcon.webp?url'
import coinGangUrl from '@/assets/games/gang/coin.webp?url'
import FreeIconGangUrl from '@/assets/games/gang/free.webp'
import FreeIconUpGangUrl from '@/assets/games/gang/free_up.webp'
import EnergyIconGangUrl from '@/assets/games/gang/gang_energy.png'
import GemIconGangUrl from '@/assets/games/gang/gang_gems.png'
import gameIconGangUrl from '@/assets/games/gang/gang_icon.jpg?url'
import connectTipGangUrl_1 from '@/assets/games/gang/goat_login_tut_gang1.webp'
import connectTipGangUrl_2 from '@/assets/games/gang/goat_login_tut_gang2.webp'
import LogInBannerBgGangUrl from '@/assets/games/gang/log_in_banner_bg.jpg?url'
import LogInBannerIconGangUrl from '@/assets/games/gang/log_in_banner_icon.png?url'
import logoGangUrl from '@/assets/games/gang/logo_TG.png?url'
import gameBannerGangUrl from '@/assets/games/gang/main_page_tg.webp?url'
import gameOfferFirstBuyImgGangUrl from '@/assets/games/gang/offer_bg.webp?url'
import LogInGangUrl from '@/assets/games/gang/shop_code_tip_tg.jpg?url'
import coinMafiaUrl from '@/assets/games/mafia/coin.webp?url'
import EnergyIconMafiaUrl from '@/assets/games/mafia/energy.png'
import FreeIconMafiaUrl from '@/assets/games/mafia/free.webp'
import FreeIconUpMafiaUrl from '@/assets/games/mafia/free_up.webp'
import GemIconMafiahUrl from '@/assets/games/mafia/gem.png'
import connectTipMafiaUrl_1 from '@/assets/games/mafia/goat_login_tut_mafia1.webp'
import connectTipMafiaUrl_2 from '@/assets/games/mafia/goat_login_tut_mafia2.webp'
import gameIconMafiaUrl from '@/assets/games/mafia/icon.jpg'
import LogInBannerBgMafiaUrl from '@/assets/games/mafia/log_in_banner_bg.jpg?url'
import LogInBannerIconMafiaUrl from '@/assets/games/mafia/log_in_banner_icon.png?url'
import logoMafiaUrl from '@/assets/games/mafia/logo.png'
import gameBannerMafiaUrl from '@/assets/games/mafia/main_page_mafia.webp?url'
import logInTipMafiaUrl from '@/assets/games/mafia/shop_code_tip.jpg'
import coinQlUrl from '@/assets/games/questland/coin.webp?url'
import FreeIconQlUrl from '@/assets/games/questland/free.webp'
import FreeIconUpQlUrl from '@/assets/games/questland/free_up.webp'
import connectTipQlUrl_1 from '@/assets/games/questland/goat_login_tut_ql1.webp'
import connectTipQlUrl_2 from '@/assets/games/questland/goat_login_tut_ql2.webp'
import LogInBannerBgQlhUrl from '@/assets/games/questland/log_in_banner_bg.jpg?url'
import LogInBannerIconQlUrl from '@/assets/games/questland/log_in_banner_icon.png?url'
import logoQlUrl from '@/assets/games/questland/logo_QL.png'
import gameBannerQlUrl from '@/assets/games/questland/main_page_ql.webp?url'
import GemIconQlUrl from '@/assets/games/questland/ql_gem.png?url'
import gameIconQlUrl from '@/assets/games/questland/ql_icon.jpg'
import logInTipQlUrl from '@/assets/games/questland/shop_code_tip_ql.jpg'
import coinSnrUrl from '@/assets/games/slashAndRoll/coin.webp?url'
import FreeIconSnrUrl from '@/assets/games/slashAndRoll/free.webp'
import FreeIconUpSnrUrl from '@/assets/games/slashAndRoll/free_up.webp'
import connectTipSlashAndRollUrl_1 from '@/assets/games/slashAndRoll/goat_login_tut_slash1.webp'
import connectTipSlashAndRollUrl_2 from '@/assets/games/slashAndRoll/goat_login_tut_slash2.webp'
import LogInBannerBgSlashAndRollUrl from '@/assets/games/slashAndRoll/log_in_banner_bg.jpg?url'
import LogInBannerIconSlashAndRollUrl from '@/assets/games/slashAndRoll/log_in_banner_icon.png?url'
import logoSlashAndRollUrl from '@/assets/games/slashAndRoll/logo_SnR.png?url'
import gameBannerSlashAndRollUrl from '@/assets/games/slashAndRoll/main_page_snr.webp?url'
import LogInSlashAndRollUrl from '@/assets/games/slashAndRoll/shop_code_tip_snr.jpg?url'
import EnergyIconSlashAndRollUrl from '@/assets/games/slashAndRoll/snr_energy.png'
import GemIconSlashAndRollUrl from '@/assets/games/slashAndRoll/snr_gem.png'
import gameIconSlashAndRollUrl from '@/assets/games/slashAndRoll/sr_icon.jpg?url'

import coinScUrl from '@/assets/games/soccerClash/coin.webp?url'
import FreeIconScUrl from '@/assets/games/soccerClash/free.webp'
import FreeIconUpScUrl from '@/assets/games/soccerClash/free_up.webp'
import connectTipSoccerClashlUrl_1 from '@/assets/games/soccerClash/goat_login_tut_soccer_1.webp'
import connectTipSoccerClashlUrl_2 from '@/assets/games/soccerClash/goat_login_tut_soccer_2.webp'
import LogInBannerBgSoccerClashUrl from '@/assets/games/soccerClash/log_in_banner_bg.jpg?url'
import LogInBannerIconSoccerClashUrl from '@/assets/games/soccerClash/log_in_banner_icon.png?url'
import logoSoccerClashlUrl from '@/assets/games/soccerClash/logo_soccer.png?url'
import gameBannerSoccerClashlUrl from '@/assets/games/soccerClash/main_page_sc.webp?url'
import EnergyIconSoccerClashUrl from '@/assets/games/soccerClash/sc_energy.png'
import GemIconSoccerClashUrl from '@/assets/games/soccerClash/sc_gems.png'
import LogInSoccerClashlUrl from '@/assets/games/soccerClash/shop_code_tip.jpg?url'
import gameIconSoccerClashlUrl from '@/assets/games/soccerClash/socer_icon.jpg?url'

import { cartDrawerGaContext, omitMinPurchaseMap, openCartDrawer } from '@/components/games/cartDrawer/CartDrawerCompose'
import { buyFreeDialog } from '@/components/layout/BuyFreeDialog/BuyFreeDialogCompose'
import { decodeGoatToken, openLoginDialog } from '@/components/layout/LoginDialog/LoginDialog'
import { payPro, url } from '@/components/layout/PayPro/PayProCompose'
import { openConnectionDialog } from '@/components/shared/GoatConnectGameDialog/GoatConnectGameDialog'
import { offerDialog, showOfferUrl } from '@/components/shared/OfferDialog/OfferDialogCompose'
import { spaI18n } from '@/compositions/i18nPlugin'
import { utilsPlugin } from '@/plugins/utilsPlugin'
import { getLocalePath } from '@/router/langRouteBuilder'
import { GameKeyEnum } from '@/types/enums'

const { cloneDeep } = pkgLodash

interface BuyContext {
  gaMethod: (params: Record<string, any>) => void
  params: Record<string, any>
}

const isProd = import.meta.env?.VITE_PROD === 'on'

// eslint-disable-next-line unused-imports/no-unused-vars -- kept on purpose (currently unused)
function isVisible(key: string) {
  if (!isProd) {
    return true
  }
  const isSsr = import.meta.env.SSR
  if (!isSsr) {
    return localStorage?.getItem?.(`id-visible_${key}`) === 'on'
  }
  return false
}

function getGameApi(game: Pick<Games.GameItem, 'gameKey' | 'apiDev' | 'apiTimeshift' | 'apiProd' | 'apiLocal'>): string {
  if (isProd)
    return game.apiProd
  try {
    const mode = useGameStore().devApiMode[game.gameKey]
    if (mode === 'local' && game.apiLocal)
      return game.apiLocal
    if (mode === 'timeshift' && game.apiTimeshift)
      return game.apiTimeshift
  } catch {
    // store not available (SSR)
  }
  return game.apiDev
}

const games: Games.GamesType = {
  gang: {
    id: 'the-gang',
    idApp: 'gang',
    name: 'The Gang',
    order: 1,
    apiDev: 'https://dev.gang-api-gamesture.com',
    apiTimeshift: 'https://timeshift.gang-api-gamesture.com',
    apiProd: 'https://prod.gang-api-gamesture.com',
    apiLocal: 'http://localhost:8094',
    get api() {
      return getGameApi(this)
    },
    logo: logoGangUrl,
    logoScale: '',
    icon: gameIconGangUrl,
    gameBanner: gameBannerGangUrl,
    active: true,
    appStore: 'https://apps.apple.com/app/the-gang-street-wars/id1599240652',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.thegang',
    logInImg: [LogInGangUrl],
    connectInImg: [connectTipGangUrl_1, connectTipGangUrl_2],
    gameKey: GameKeyEnum.gang,
    logInBanner: {
      icon: LogInBannerIconGangUrl,
      bg: LogInBannerBgGangUrl,
      bgColor: '#02232e',
      customClass: {
        vertical: 'h-[180%] left-1/2 -translate-x-1/2 -translate-y-8',
        horizontal: 'big:h-[150%] big:-translate-y-5'
      }
    },
    energy: {
      url: EnergyIconGangUrl,
      customClass: 'w-8 -left-3.5'
    },
    gems: {
      url: GemIconGangUrl,
      customClass: 'w-7 -left-3.5',
      storeBonusClass: ''
    },
    itemIconClass: 'max-h-full',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/bucket-gang-files/',
    gemTabName: 'gameCategory.gems',
    freeIcon: FreeIconGangUrl,
    freeIconUp: FreeIconUpGangUrl,
    loyalty: {
      icon: coinGangUrl
    },
    gemFirstBuyBgImg: gameOfferFirstBuyImgGangUrl,
    tileGemsImgClass: 'scale-[0.9]',
    isEnabledMilestones: true
  },
  slashAndRoll: {
    id: 'slash-and-roll',
    idApp: 'slash-and-roll',
    name: 'Slash&Roll',
    order: 2,
    apiDev: 'https://dev.sw-api-gamesture.com',
    apiTimeshift: 'https://timeshift.sw-api-gamesture.com',
    apiProd: 'https://prod.sw-api-gamesture.com',
    apiLocal: 'http://localhost:8094',
    get api() {
      return getGameApi(this)
    },
    logo: logoSlashAndRollUrl,
    logoScale: '',
    icon: gameIconSlashAndRollUrl,
    gameBanner: gameBannerSlashAndRollUrl,
    active: true,
    appStore: 'https://apps.apple.com/app/id1566838404',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.team.guild.raids.pvp.multiplayer',
    logInImg: [LogInSlashAndRollUrl],
    connectInImg: [connectTipSlashAndRollUrl_1, connectTipSlashAndRollUrl_2],
    gameKey: GameKeyEnum.slashAndRoll,
    logInBanner: {
      icon: LogInBannerIconSlashAndRollUrl,
      bg: LogInBannerBgSlashAndRollUrl,
      bgColor: '#003867',
      customClass: {
        vertical: undefined,
        horizontal: undefined
      }
    },
    energy: {
      url: EnergyIconSlashAndRollUrl,
      customClass: 'w-7 -left-3.5'
    },
    gems: {
      url: GemIconSlashAndRollUrl,
      customClass: 'w-8 -left-4',
      storeBonusClass: ''
    },
    itemIconClass: 'max-h-full',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/bucket-sw-files/',
    gemTabName: 'gameCategory.gems',
    freeIcon: FreeIconSnrUrl,
    freeIconUp: FreeIconUpSnrUrl,
    loyalty: {
      icon: coinSnrUrl
    },
    gemFirstBuyBgImg: gameOfferFirstBuyImgGangUrl,
    tileGemsImgClass: '',
    isEnabledMilestones: true
  },
  soccerClash: {
    id: 'soccer-clash',
    idApp: 'soccer-clash',
    name: 'Soccer Clash',
    order: 3,
    apiDev: 'https://soccer-dev.netto-api-gamesture.com',
    apiTimeshift: 'https://soccer-timeshift.netto-api-gamesture.com',
    apiProd: 'https://soccer-prod.netto-api-gamesture.com',
    apiLocal: 'http://localhost:8097',
    get api() {
      return getGameApi(this)
    },
    logo: logoSoccerClashlUrl,
    logoScale: '',
    icon: gameIconSoccerClashlUrl,
    gameBanner: gameBannerSoccerClashlUrl,
    active: true,
    appStore: 'https://apps.apple.com/app/soccer-clash-football-game/id6470202226',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.soccer.clash.football.world.sport.league',
    logInImg: [LogInSoccerClashlUrl],
    connectInImg: [connectTipSoccerClashlUrl_1, connectTipSoccerClashlUrl_2],
    gameKey: GameKeyEnum.soccerClash,
    logInBanner: {
      icon: LogInBannerIconSoccerClashUrl,
      bg: LogInBannerBgSoccerClashUrl,
      bgColor: '#003b26',
      customClass: {
        vertical: 'h-[130%] left-1/2 -translate-x-1/2 -translate-y-2.5',
        horizontal: 'big:h-[140%] big:-translate-y-3.5'
      }
    },
    energy: {
      url: EnergyIconSoccerClashUrl,
      customClass: 'w-6 -left-2'
    },
    gems: {
      url: GemIconSoccerClashUrl,
      customClass: 'w-8 -left-4',
      storeBonusClass: ''
    },
    itemIconClass: 'max-h-full',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/bucket-soccer-files/',
    gemTabName: 'gameCategory.bucks',
    freeIcon: FreeIconScUrl,
    freeIconUp: FreeIconUpScUrl,
    loyalty: {
      icon: coinScUrl
    },
    gemFirstBuyBgImg: gameOfferFirstBuyImgGangUrl,
    tileGemsImgClass: '',
    isEnabledMilestones: true
  },
  questland: {
    id: 'questland',
    idApp: 'questland',
    name: 'Questland',
    order: 4,
    apiDev: 'https://dev.ql-api-gamesture.com',
    apiTimeshift: '',
    apiProd: 'https://prod.ql-api-gamesture.com',
    apiLocal: '',
    get api() {
      return getGameApi(this)
    },
    logo: logoQlUrl,
    logoScale: '',
    icon: gameIconQlUrl,
    gameBanner: gameBannerQlUrl,
    active: true,
    appStore: 'https://apps.apple.com/pl/app/questland-turn-based-rpg/id1079884680',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.questland',
    logInImg: [logInTipQlUrl],
    connectInImg: [connectTipQlUrl_1, connectTipQlUrl_2],
    gameKey: GameKeyEnum.questland,
    logInBanner: {
      icon: LogInBannerIconQlUrl,
      bg: LogInBannerBgQlhUrl,
      bgColor: '#08203B',
      customClass: {
        vertical: 'h-[110%]  left-1/2 -translate-x-1/2',
        horizontal: 'big:h-[90%]  big:translate-y-1'
      }
    },
    energy: {
      url: '',
      customClass: ''
    },
    gems: {
      url: GemIconQlUrl,
      customClass: 'w-8 -left-4',
      storeBonusClass: 'scale-[1.8]'
    },
    itemIconClass: '-translate-y-[20%]',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/ql4-files-eu/',
    gemTabName: 'gameCategory.gems',
    freeIcon: FreeIconQlUrl,
    freeIconUp: FreeIconUpQlUrl,
    loyalty: {
      icon: coinQlUrl
    },
    gemFirstBuyBgImg: gameOfferFirstBuyImgGangUrl,
    tileGemsImgClass: 'scale-[1.7]',
    isEnabledMilestones: false
  },
  mafia: {
    id: 'mafia',
    idApp: 'mafia',
    name: 'Mafia Rivals',
    order: 5,
    apiDev: 'https://mafia-dev.netto-api-gamesture.com',
    apiTimeshift: '',
    apiProd: 'https://mafia-prod.netto-api-gamesture.com',
    apiLocal: 'http://localhost:8097',
    get api() {
      return getGameApi(this)
    },
    logo: logoMafiaUrl,
    logoScale: 'scale-[0.7]',
    icon: gameIconMafiaUrl,
    gameBanner: gameBannerMafiaUrl,
    active: true,
    appStore: 'https://apps.apple.com/app/mafia-rivals-grand-wars/id6478916867',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.mafia',
    logInImg: [logInTipMafiaUrl],
    connectInImg: [connectTipMafiaUrl_1, connectTipMafiaUrl_2],
    gameKey: GameKeyEnum.mafia,
    logInBanner: {
      icon: LogInBannerIconMafiaUrl,
      bg: LogInBannerBgMafiaUrl,
      bgColor: '#02232e',
      customClass: {
        vertical: 'h-[180%] left-1/2 -translate-x-1/2 -translate-y-8',
        horizontal: 'big:h-[150%] big:-translate-y-5'
      }
    },
    energy: {
      url: EnergyIconMafiaUrl,
      customClass: 'w-8 -left-4'
    },
    gems: {
      url: GemIconMafiahUrl,
      customClass: 'w-8 -left-4',
      storeBonusClass: ''
    },
    itemIconClass: 'max-h-full',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/bucket-mafia-files/',
    gemTabName: 'gameCategory.gold',
    freeIcon: FreeIconMafiaUrl,
    freeIconUp: FreeIconUpMafiaUrl,
    loyalty: {
      icon: coinMafiaUrl
    },
    gemFirstBuyBgImg: gameOfferFirstBuyImgGangUrl,
    tileGemsImgClass: '',
    isEnabledMilestones: true
  },
  cooking: {
    id: 'cooking-wars',
    idApp: 'cooking-wars',
    name: 'Cooking Wars',
    order: 6,
    apiDev: 'https://cooking-dev.netto-api-gamesture.com',
    apiTimeshift: 'https://cooking-time.netto-api-gamesture.com',
    apiProd: 'https://cooking-prod.netto-api-gamesture.com',
    apiLocal: 'http://localhost:8097',
    get api() {
      return getGameApi(this)
    },
    logo: logoCookingWarsUrl,
    logoScale: '',
    icon: iconCookingWarsUrl,
    gameBanner: gameBannerCookingWarsUrl,
    active: true,
    appStore: 'https://apps.apple.com/us/app/cooking-wars-food-battle/id6741325291',
    googleStore: 'https://play.google.com/store/apps/details?id=com.gamesture.cookingwars',
    logInImg: [logInCookingWarsUrl_1],
    connectInImg: [connectTipCookingWarsUrl_1, connectTipCookingWarsUrl_2],
    gameKey: GameKeyEnum.cooking,
    logInBanner: {
      icon: logInBannerIconCookingWarsUrl,
      bg: logInBannerBgCookingWarsUrl,
      bgColor: '#051A24',
      customClass: {
        vertical: 'h-[130%] left-1/2 -translate-x-1/2 -translate-y-2.5',
        horizontal: 'big:h-[140%] big:-translate-y-3.5'
      }
    },
    energy: {
      url: energyIconCookingWarsUrl,
      customClass: 'w-8 -left-3.5'
    },
    gems: {
      url: '',
      customClass: 'w-7 -left-3.5',
      storeBonusClass: ''
    },
    itemIconClass: 'max-h-full',
    enableCart: true,
    imgStorageUrl: 'https://storage.googleapis.com/bucket-cooking-files/',
    gemTabName: 'gameCategory.energyAndGold',
    freeIcon: freeIconCookingWarsUrl,
    freeIconUp: freeIconUpCookingWarsUrl,
    loyalty: {
      icon: loyaltyIconCookingWarsUrl
    },
    gemFirstBuyBgImg: gemFirstBuyCookingWarsUrl,
    tileGemsImgClass: '',
    isEnabledMilestones: true
  }
}

const gameOrder = Object.entries(games)
  .sort((a, b) => a[1].order - b[1].order)
  .map(([gameKey]) => gameKey as Games.GameKeyType)

const listById = Object.fromEntries(Object.entries(games).map(([, game]) => [game.id, game]))

const routeGame = computed<Games.GameItem | null>(() => {
  return listById?.[String(utilsPlugin.getApp()?.$route?.params?.gameID)] || null
})
const routeGameKey = computed<Games.GameKeyType>(() => {
  return listById?.[String(utilsPlugin.getApp()?.$route?.params?.gameID)]?.gameKey || ''
})

function isLoggedGame(gameKey: Games.GameKeyType) {
  return !!useGameStore().token(gameKey)?.token
}

function isConnectedAllToGoat(gameKey: Games.GameKeyType) {
  if (gameKey === GameKeyEnum.goat) {
    const tokens = getGameTokens()
    return !Object.values(games).some((gameSet) => {
      if (!gameSet.active || gameSet.gameKey === GameKeyEnum.goat) {
        return false
      }
      return !tokens?.[gameSet.gameKey]?.token
    })
  } else {
    return isLoggedGame(gameKey)
  }
}
function isSomeConnectedToGoat(gameKey: Games.GameKeyType) {
  if (gameKey === GameKeyEnum.goat) {
    return Object.entries(getGameTokens()).some(([keyOfGame, tokenData]) => {
      if (keyOfGame === GameKeyEnum.goat) {
        return false
      }
      return tokenData?.token?.length > 0
    })
  } else {
    return isLoggedGame(gameKey)
  }
}

/**
 * only to use on gamePages;
 */
const isLogged = computed(() => {
  return !!useGameStore().token(routeGame.value?.gameKey)?.token
})
const isLoggedGoat = computed(() => {
  return !!useGameStore().token(GameKeyEnum.goat)?.token
})
const getGoatData = computed<Token>(() => {
  return useGameStore().token(GameKeyEnum.goat) as Token
})
const gameLoggedOrder = computed(() => {
  return [...gameOrder].sort((a, b) => {
    return (useGameStore().token(b) ? 1 : 0) - (useGameStore().token(a) ? 1 : 0)
  }).filter(gameKey => games?.[gameKey]?.active)
})

const loading = ref('')

const { gaRemoveFromCart, gaSections } = gaUtils

function getGameSettings(gameKey: Games.GameKeyLax): Games.GameItem | null {
  if (gameKey) {
    return games?.[gameKey] || null
  }
  return null
}

function setGameToken(gameKey: Games.GameKeyLax, token: Token | null) {
  if (gameKey) {
    useGameStore().setToken(gameKey, token as Token)
  }
}

function getGameToken(gameKey: Games.GameKeyLax): Token | null {
  if (gameKey) {
    return useGameStore().token(gameKey) || null
  }
  return null
}

function getGameTokens(): Record<string, Token> {
  return useGameStore().getTokens
}

function clearGameTokens() {
  useGameStore().clearTokens()
}

function buildDeepLink(idApp: string, backPath: string, gameKey: string, offerID: string | number, login = true) {
  const mode = import.meta.env.VITE_PROD === 'on' ? '' : 'dev-'
  let domain = ''
  if (window.location.hostname === 'localhost') {
    domain = `http://${window.location.host}`
  } else {
    domain = `${window.location.protocol}//${mode.length ? 'gamesture-store-dev.vercel.app' : 'www.store.gamesture.com'}`
  }
  return `${domain}/deep-link/game/${mode}${idApp}?login=${login ? 'true' : 'false'}&route=${encodeURIComponent(backPath || '')}&gameKey=${gameKey || ''}${offerID ? `&offerId=${offerID || ''}` : ''}`
}

const gameLoyalty = computed<Games.Lax<Games.Loyalty>>(() => {
  return useGameStore().loyaltyFor(routeGame.value?.gameKey)
})
function numbersShortHuman(number: number) {
  if (number >= 10_000) {
    if (number >= 1000_000_000) {
      return `${Number.parseFloat((Math.round((number / 1000_000_000) * 100) / 100).toFixed(2))}G`
    } else if (number >= 1000_000) {
      return `${Number.parseFloat((Math.round((number / 1000_000) * 100) / 100).toFixed(2))}M`
    } else {
      return `${Number.parseFloat((Math.round((number / 1_000) * 100) / 100).toFixed(2))}k`
    }
  }
  return `${number}`
}
function renderApiOffers(
  apiData: Array<Games.Offer>,
  gameKey: Games.GameKeyType,
  gaContext: GaUtils.GaContext,
  pageOfferId = 0,
  moId = 0
): { offers: Array<Games.Offer>, pageOffer: Games.Offer | null } {
  const moGroupIdMap: Record<number, number> = {}
  let renderedOffers: Array<Games.Offer> = []
  let excludedIndex = -1
  let excluded: Games.Offer | null = null
  const uniqOffers: Array<Games.Offer> = []
  const uniqOffersMap: Record<number | string, boolean> = {}
  /**
   * securing uniqueness
   */
  apiData.forEach((item: Games.Offer) => {
    if (!uniqOffersMap[item?.id ?? '']) {
      uniqOffers.push(item)
    }
    uniqOffersMap[item?.id ?? ''] = true
  })
  /**
   * grouping multiOffers;
   * and other fields
   */
  const imgStorageUrl = games?.[gameKey]?.imgStorageUrl ?? ''
  uniqOffers.forEach((item: Games.Offer, index) => {
    item.gameKey = gameKey
    item.gaContext = { ...(gaContext ?? {}) }
    item._loyaltyPoints = item?.loyaltyPoints ? numbersShortHuman(item?.loyaltyPoints || 0) : ''
    if (item.extraValueInfo === 'free') {
      item.extraValueInfo = 'FREE'
    }
    if (item.items?.length) {
      for (const offerItem of item.items) {
        offerItem._amountShort = offerItem.amount ? numbersShortHuman(offerItem.amount || 0) : ''
        offerItem._bonusAmountShort = offerItem.bonusAmount ? numbersShortHuman(offerItem.bonusAmount || 0) : ''
        if (imgStorageUrl.length) {
          if (offerItem.asset && offerItem.asset.slice(0, 4) !== 'http') {
            offerItem.asset = imgStorageUrl + offerItem.asset
          }
        }
      }
    }
    if (imgStorageUrl.length) {
      if (item.asset && item.asset.slice(0, 4) !== 'http') {
        item.asset = imgStorageUrl + item.asset
      }
    }
    if (pageOfferId && item?.id === pageOfferId) {
      excludedIndex = index
    }
    if (item?.moGroupId) {
      item.isMultiOffer = true
      if (moGroupIdMap?.[item.moGroupId] === undefined) {
        item.multiOffers = [{ ...item }]
        moGroupIdMap[item.moGroupId] = renderedOffers.push(item) - 1
      } else {
        renderedOffers[moGroupIdMap[item.moGroupId] ?? -1]?.multiOffers?.push(item)
      }
    } else {
      renderedOffers.push(item)
    }
  })
  if (uniqOffers?.[excludedIndex]) {
    excluded = uniqOffers[excludedIndex] ?? null
  } else if (moId && moGroupIdMap[moId]) {
    excluded = renderedOffers[moGroupIdMap[moId]] ?? null
  }
  /**
   * sets the purchasable offer as root multiOffer
   */
  Object.entries(moGroupIdMap).forEach(([, index]) => {
    const validatedMultiOffer = renderedOffers[index]
    if (!!validatedMultiOffer?.moIsLocked || !!validatedMultiOffer?.isBought) {
      validatedMultiOffer?.multiOffers?.some((offer) => {
        if (!(!!offer?.moIsLocked || !!offer?.isBought)) {
          offer.multiOffers = validatedMultiOffer.multiOffers
          offer.isMultiOffer = true
          renderedOffers[index] = offer
          return true
        }
        return false
      })
    }
  })
  /**
   * remove expired offers or root multiOffers that are bought or locked
   * set pageOffer (used by offer page (null pageOffer means that the offer is no longer available (including expired);
   */
  const excludedMoGroupId = excluded?.moGroupId || 0
  excluded = excluded as Games.Offer | null
  renderedOffers = renderedOffers.filter((filterOffer) => {
    /**
     * remove logic
     */
    if ((filterOffer?.expireSec || 0) < 0 || (filterOffer?.moGroupId && (filterOffer?.isBought || filterOffer?.moIsLocked))) {
      return false
    }
    /**
     * exclude logic
     */
    if (
      pageOfferId &&
      ((excludedMoGroupId && filterOffer?.moGroupId === excludedMoGroupId) ||
        (!excludedMoGroupId && pageOfferId === filterOffer.id))
    ) {
      excluded = filterOffer
      return false
    }
    return true
  })
  /**
   *  remove nested multiOffers; sort multiOffers;
   */
  renderedOffers.forEach((offer) => {
    if (offer.multiOffers) {
      offer.multiOffers = cloneDeep(offer.multiOffers)
      offer.multiOffers.forEach((multiItem) => {
        if (multiItem.multiOffers) {
          delete multiItem.multiOffers
        }
      })
      offer.multiOffers.sort((a, b) => {
        if (a.id === offer?.id)
          return -1
        if (b.id === offer?.id)
          return 1
        return 0
      })
    }
  })
  if (excluded?.multiOffers) {
    excluded.multiOffers = cloneDeep(excluded.multiOffers)
    excluded.multiOffers.forEach((multiItem) => {
      if (multiItem.multiOffers) {
        delete multiItem.multiOffers
      }
    })
    excluded.multiOffers.sort((a, b) => {
      if (a.id === excluded?.id)
        return -1
      if (b.id === excluded?.id)
        return 1
      return 0
    })
  }
  return { offers: renderedOffers, pageOffer: excluded }
}

function sortByIsBought(offers: Array<Games.Offer>) {
  offers.sort((a, b) => {
    if (b.isBought) {
      return -1
    }
    if (a.isBought) {
      return 1
    }
    return 0
  })
  return offers
}
function checkCart(apiData: Array<Games.Offer>, gameKey: Games.GameKeyType) {
  /**
   * cart refresh logic;
   * isLogged works only on gamePage so can't be used;
   * only offers on game pages are removed because there is only a complete list there
   */
  const isLoggedUser = !!useGameStore().token(gameKey)?.token
  if (isLoggedUser && games?.[gameKey]?.enableCart) {
    const mapApiOffers: Record<number | string, Games.Offer> = {}
    apiData.forEach((item: Games.Offer) => {
      mapApiOffers[item?.id ?? ''] = item
    })

    const cart: Games.Offer[] = useGameStore().gameCart(gameKey)
    if (cart.length) {
      for (const cartIndex in cart) {
        const offerNewData = mapApiOffers?.[cart[cartIndex]?.id ?? 0]
        if ((!offerNewData?.id && !!routeGame.value?.gameKey) || offerNewData?.isFree || offerNewData?.isBought) {
          const cartItem = cart[cartIndex]
          gaRemoveFromCart(
            {
              items: [{
                item_id: String(cartItem?.id),
                item_name: cartItem?.product || cartItem?.name,
                index: Number.parseInt(cartIndex || '0'),
                quantity: cartItem?.qty ?? 1,
                price: cartItem?.discount?.value || cartItem?.price?.value
              }],
              value: cartItem?.discount?.value || cartItem?.price?.value,
              currency: cartItem?.price?.currency,
              gs_game: gameKey,
              gs_route: String(utilsPlugin.getApp()?.$route.name),
              gs_section: gaSections.cartChecker,
              gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
            }
          )
          useGameStore().removeFromGameCart(gameKey, Number(cartIndex))
        } else {
          const diffQty = (cart[cartIndex]?.qty ?? 1) - (offerNewData?.allowQty ? offerNewData?.purchaseLimit ?? 1 : 1)
          if (diffQty > 0) {
            const cartItem = cart[cartIndex]
            gaRemoveFromCart(
              {
                items: [{
                  item_id: String(cartItem?.id),
                  item_name: cartItem?.product || cartItem?.name,
                  index: Number.parseInt(cartIndex || '0'),
                  quantity: diffQty,
                  price: (cartItem?.discount?.value || cartItem?.price?.value || 0)
                }],
                value: (cartItem?.discount?.value || cartItem?.price?.value || 0) * diffQty,
                currency: cartItem?.price?.currency,
                gs_game: gameKey,
                gs_route: String(utilsPlugin.getApp()?.$route.name),
                gs_section: gaSections.cartChecker,
                gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
              }
            )
            if (offerNewData) {
              offerNewData.qty = (offerNewData?.purchaseLimit ?? 1) || 1
            }
            if (offerNewData?.multiOffers) {
              delete offerNewData.multiOffers
            }
          }
          if (offerNewData) {
            useGameStore().updateGameCartOffer(gameKey, offerNewData, Number(cartIndex))
          }
        }
      }
    }
  }
}

function showError(optionsNotify: Partial<NotificationOptions> | null = null) {
  let customClass = 'child-inherit-colors text-red-600 z-999999 right-1/2 translate-x-1/2 large max-w-full'
  if (optionsNotify?.appendTo) {
    customClass += ' absolute'
  }
  const t = spaI18n.global.t
  const defaultConfig = {
    title: t('gamesUtils.error'),
    type: 'warning',
    customClass,
    message: t('gamesUtils.oopsSomethingWentWrong'),
    duration: 9000
  }
  utilsPlugin.getApp()?.$notify?.closeAll()
  utilsPlugin.getApp()?.$notify({ ...defaultConfig, ...(optionsNotify ?? {}) })
}

function apiGet(gameKey: Games.GameKeyType, endPoint: string, params: Record<string, any> | null = null, auth = true, apiPrefix = 'store/api/'): Promise<AxiosResponse> {
  const app = utilsPlugin.getApp()
  const game = getGameSettings(gameKey)
  let headers
  const token = useGameStore().token(gameKey)?.token
  let loggedPreffix = ''
  if (game?.api) {
    if (auth && token) {
      loggedPreffix = 'user/'
      headers = { Token: token }
    }
    return app?.$axios.get(`${game.api}/${apiPrefix}${loggedPreffix}${endPoint}`, { params, headers })
  } else if (gameKey === GameKeyEnum.goat) {
    headers = { Authorization: useGameStore().token(GameKeyEnum.goat)?.token }
    return app?.$axios.get(`${endPoint}`, { params, headers })
  }
  return new Promise(resolve => resolve({} as AxiosResponse))
}

function apiPost(gameKey: Games.GameKeyType, endPoint: string, params: Record<string, any> | null = null, auth = true, apiPrefix = 'store/api/'): Promise<AxiosResponse> {
  const app = utilsPlugin.getApp()
  const game = getGameSettings(gameKey)
  let headers
  const token = useGameStore().token(gameKey)?.token
  let loggedPreffix = ''
  if (game?.api) {
    if (auth && token) {
      loggedPreffix = 'user/'
      headers = { Token: token }
    }
    return app?.$axios.post(`${game.api}/${apiPrefix}${loggedPreffix}${endPoint}`, params, { headers })
  } else if (gameKey === GameKeyEnum.goat) {
    headers = { Authorization: useGameStore().token(GameKeyEnum.goat)?.token }
    return app?.$axios.post(`${endPoint}`, params, { headers })
  }
  return new Promise(resolve => resolve({} as AxiosResponse))
}

function catchError(error: Error | boolean | AxiosError) {
  if (error instanceof AxiosError) {
    utilsPlugin.getApp()?.$notify?.closeAll()
    utilsPlugin.getApp()?.$notify({
      title: spaI18n.global.t('gamesUtils.error'),
      type: 'warning',
      customClass: 'child-inherit-colors text-red-600 z-999999 max-w-full',
      message: `${error?.response?.data?.message || error?.response?.data?.errors?.[0] || error}`,
      duration: 9000
    })
  } else if (error instanceof Error) {
    console?.error?.(error)
  }
}
function catchNotifyError(optionsNotify = {} as Record<string, any>) {
  return (error: Error | boolean | AxiosError) => {
    if (error instanceof AxiosError) {
      let customClass = 'child-inherit-colors text-red-600 z-999999 right-1/2 translate-x-1/2 large max-w-full'
      if (optionsNotify.appendTo) {
        customClass += ' absolute'
      }
      utilsPlugin.getApp()?.$notify?.closeAll()
      utilsPlugin.getApp()?.$notify({
        title: spaI18n.global.t('gamesUtils.error'),
        type: 'warning',
        customClass,
        message: `${error?.response?.data?.message || error?.response?.data?.errors?.[0] || error}`,
        duration: 9000,
        offset: 100,
        ...(optionsNotify ?? {})
      })
    } else if (error instanceof Error) {
      console?.error?.(error)
    }
  }
}
function catchFormErrors(externalErrors: Record<string, any>, optionsNotify = {} as Record<string, any>) {
  return (error: Error | boolean | AxiosError) => {
    if (error instanceof AxiosError &&
      error?.response?.status &&
      error?.response?.status < 401 &&
      error.response?.data?.status === 'error' &&
      error.response?.data?.errors) {
      let isMatchedFieldError = false
      let errorPopupMsg = ''
      const fieldErrors = error.response.data.errors
      Object.entries(fieldErrors).forEach(([fieldName, errorValue]) => {
        if (fieldName in externalErrors) {
          isMatchedFieldError = true
          externalErrors[fieldName] = errorValue
          delete fieldErrors[fieldName]
        }
      })
      errorPopupMsg = Object.entries(fieldErrors)
        .map(([, val]) => {
          return val
        })
        .join(', ')
      if (isMatchedFieldError) {
        errorPopupMsg = `Not all fields are valid! <br/>${errorPopupMsg}`
      }
      if (errorPopupMsg) {
        let customClass = 'child-inherit-colors text-red-600 z-999999 right-1/2 translate-x-1/2 large max-w-full'
        if (optionsNotify.appendTo) {
          customClass += ' absolute'
        }
        utilsPlugin.getApp()?.$notify({
          title: spaI18n.global.t('gamesUtils.error'),
          type: 'warning',
          customClass,
          message: `${errorPopupMsg || ''}`,
          duration: 9000,
          offset: 100,
          ...(optionsNotify ?? {})
        })
      }
    } else {
      catchNotifyError(optionsNotify)(error)
    }
  }
}

function setLoyalty(gameKey: Games.GameKeyType, apiLoyaltyData: Games.Lax<Games.ApiLoyaltyData>) {
  useGameStore().setLoyalty(gameKey, apiLoyaltyData)
}
async function getBuyOfferFromApi(buyOffer: Games.Offer): Promise<{ offers: Array<Games.Offer>, pageOffer: Games.Offer | null }> {
  const gameKey = buyOffer?.gameKey
  let renderedApiBuyOffers: { offers: Array<Games.Offer>, pageOffer: Games.Offer | null } = { offers: [], pageOffer: null }
  if (gameKey) {
    await apiGet(gameKey, 'offers/game/')
      .then(({ data }) => {
        setLoyalty(gameKey, data?.storeUser)
        const id = String(buyOffer?.id)
        const moID = buyOffer?.moGroupId || 0
        const allApiOffers: Array<Games.Offer> = []
        if (data.offers) {
          allApiOffers.push(...data.offers)
        }
        renderedApiBuyOffers = renderApiOffers(
          allApiOffers,
          gameKey,
          buyOffer?.gaContext ?? {},
          Number.parseInt(id),
          moID
        )
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.status === 401) {
          if (gameKey) {
            useGameStore().logOut(gameKey)
          }
        } else {
          catchError(err)
        }
      })
  }
  return renderedApiBuyOffers
}
const triggerRef = ref(0)
const isVisibleDocument = useDocumentVisibility()
const triggerApi = {
  triggerRef,
  callTrigger: (delay = 0) => {
    if (delay) {
      setTimeout(() => {
        triggerRef.value = ++triggerRef.value % 10
      }, delay)
    } else {
      triggerRef.value = ++triggerRef.value % 10
    }
  },
  initTriggerApi: () => {
    const isSsr = import.meta.env.SSR
    if (!isSsr) {
      checkBuildVersion(true)
      const timeout = 60
      const intervalID = setInterval(() => {
        if (!payPro.visibility.value && isVisibleDocument.value !== 'hidden') {
          checkBuildVersion()
          triggerApi.callTrigger()
        }
      }, timeout * 1000)

      const route = useRoute()
      watch(
        () => `${route.path}_${getGameToken(routeGame.value?.gameKey)?.token}`,
        () => {
          if (/:[a-z]/i.test(route.path))
            return
          triggerApi.callTrigger()
        }
      )

      onUnmounted(() => {
        if (intervalID) {
          clearInterval(intervalID)
        }
      })
    }
  }
}

function buyFree(offer: Games.Offer, loadingRefer: VueRef<string>, context: BuyContext | null = null) {
  if (offer?.gameKey && offer?.id) {
    const currentOffer = { ...offer }
    loadingRefer.value = `${currentOffer.gameKey}_${currentOffer.id}`
    buyFreeDialog.value.offer = currentOffer
    const { gaBeginCheckout, gaPurchase } = gaUtils
    if (context) {
      gaBeginCheckout({
        ...(offer?.gaContext ?? {}),
        ...context.params,
        gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
      })
    }
    apiGet(currentOffer.gameKey, 'getfree/', { offer_id: currentOffer.id })
      .then(() => {
        if (context) {
          buyFreeDialog.value.visible = true
          triggerApi.callTrigger(100)
          gaPurchase({
            ...(offer?.gaContext ?? {}),
            ...context.params,
            gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.status === 401) {
          logOut(currentOffer.gameKey, err)
        } else {
          catchError(err)
        }
      })
      .then(() => {
        loadingRefer.value = ''
      })
  }
}

const buyOffer: VueRef<Games.Offer | null> = ref(null)

function logOut(gameKey: Games.GameKeyLax, error: ApiError = {}) {
  if (gameKey) {
    if (gameKey === GameKeyEnum.goat) {
      useGameStore().logOutAll()
    } else {
      useGameStore().logOut(gameKey)
    }
    if (error?.response?.data?.ban) {
      useGameStore().setLogBan(gameKey as Games.GameKeyType, String(error?.response?.data?.ban))
    }
  }
  buyOffer.value = null
  goadLoadAliveData()
}

function showCheckoutCart(openFrom = '', cartGameKey: Games.GameKeyLax | '' = null) {
  let gameKey: Games.GameKeyType = ''
  const products: string[] = []
  const amounts: number[] = []
  const offerids: number[] = []
  const gaProducts: Games.Offer[] = []
  const multiOffer: Record<'offer', Games.Offer | null> = { offer: null }
  const redirectParams = {
    gameKey: '',
    moGroupId: ''
  }
  let idPageTemplate = 18543
  if (import.meta.env.VITE_PROD !== 'on') {
    idPageTemplate = 18539
  }
  const domain = `${window.location.protocol}//${window.location.host}`
  const customParams: Record<string, string> = {
    'page-template': `${idPageTemplate}`,
    'exfo': '742'
  }
  let redirect = window?.location?.origin || import.meta.env.VITE_HOST || 'https://store.gamesture.com'
  gameKey = routeGame.value?.gameKey ?? (cartGameKey || '')
  loading.value = openFrom
  const gameCart: Games.Offer[] = useGameStore().gameCart(gameKey)
  gaProducts.push(...gameCart)
  gameCart.forEach((cartOffer) => {
    products.push(cartOffer?.hash ?? '')
    amounts.push(cartOffer?.qty ?? 1)
    if (cartOffer?.id) {
      const id = typeof cartOffer.id === 'string' ? Number.parseInt(cartOffer.id) : cartOffer.id
      offerids.push(id)
      if (cartOffer.isMultiOffer) {
        if (!multiOffer.offer) {
          multiOffer.offer = cartOffer
        } else if ((cartOffer?.discount?.value || cartOffer?.price?.value || 0) > (multiOffer.offer?.discount?.value || multiOffer.offer?.price?.value || 0)) {
          multiOffer.offer = cartOffer
        }
      }
    }
  })
  redirect += `/game/${games?.[gameKey]?.id}`
  if (multiOffer.offer?.id) {
    redirect += `/offer/${multiOffer.offer.id}`
    redirectParams.moGroupId = `${multiOffer.offer.moGroupId}`
  }

  const gameIcon = games?.[gameKey]?.icon || ''
  if (gameIcon) {
    customParams['x-game-logo'] = domain + gameIcon
  }
  if (games?.[gameKey]?.imgStorageUrl) {
    customParams['x-img-storage'] = games?.[gameKey]?.imgStorageUrl ?? ''
  }
  if (gaProducts.length) {
    let sumValue = 0
    const items = gaProducts.map((gaOffer, gaIndex) => {
      sumValue += gaOffer?.discount?.value || gaOffer?.price?.value || 0
      return {
        item_id: String(gaOffer?.id),
        item_name: String(gaOffer?.product || gaOffer?.name),
        index: gaIndex || 0,
        quantity: gaOffer?.qty ?? 1,
        price: gaOffer?.discount?.value || gaOffer?.price?.value || 0
      }
    })
    const purchaseSections = []
    if (openFrom.slice(0, 7) === 'payment') {
      purchaseSections.push(gaSections.paymentDialog)
    }
    purchaseSections.push(cartDrawerGaContext.value?.gs_section || gaSections.cart)
    const { gaBeginCheckout } = gaUtils
    gaBeginCheckout({
      currency: gaProducts?.[0]?.price?.currency || '',
      value: sumValue,
      items,
      gs_game: gaProducts?.[0]?.gameKey,
      gs_route: gaProducts?.[0]?.gaContext?.gs_route || String(utilsPlugin.getApp()?.$route.name),
      gs_section: purchaseSections.join(','),
      gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
    })
  }
  redirectParams.gameKey = gameKey
  const isNeon = useGameStore().gameCartMinVal(gameKey) === 0
  let returnUrl
  if (isNeon) {
    returnUrl = `${redirect}?r_p=${redirectParams.gameKey},${redirectParams.moGroupId}`
  }

  apiPost(gameKey, 'purchase/', {
    products,
    amounts,
    offerids,
    customFields: { ...customParams },
    returnUrl
  })
    .then(({ data }) => {
      if (data?.url) {
        if (useGameStore().gameCartMinVal(gameKey) === 0) {
          url.value = data.url
        } else {
          url.value = `${data.url}&x-redirect_target=${redirect}`
        }
        payPro.visibility.value = true
      } else {
        loading.value = ''
        showError({ message: spaI18n.global.t('gamesUtils.oopsSomethingWentWrong') })
      }
    })
    .catch((err) => {
      loading.value = ''
      if (err?.response?.status === 401 || err?.status === 401) {
        buyOffer.value = null
        logOut(gameKey, err)
        openLoginDialog(gameKey, {})
      } else {
        catchError(err)
      }
    })
}

function buy(offer: Games.Offer, loadingRefer: VueRef<string>, context: BuyContext | null = null) {
  buyOffer.value = offer
  if (!getGameToken(offer?.gameKey)) {
    if (isLoggedGoat.value && offer?.gameKey !== GameKeyEnum.goat) {
      if (context) {
        context.gaMethod(
          {
            ...(offer?.gaContext ?? {}),
            ...context.params,
            gs_context: `${gaUtils.gaBuyBtnContext.goat_account},${gaUtils.gaBuyBtnContext.connection_game_required}`
          }
        )
      }
      openConnectionDialog(offer?.gameKey, true)
    } else {
      const offerContext = { ...(offer?.gaContext ?? {}) }
      if (offerContext?.gs_section?.length) {
        offerContext.gs_section += `,${gaSections.buyBtn}`
      } else {
        offerContext.gs_section = gaSections.buyBtn
      }
      if (context) {
        context.gaMethod(
          {
            ...offerContext,
            ...context.params,
            gs_context: gaUtils.gaBuyBtnContext.not_logged_in
          }
        )
      }
      openLoginDialog(offer?.gameKey, offerContext)
    }
    return
  }
  if ((offer?.expireSec || 0) < 0 ||
    !!offer?.isBought ||
    !!offer?.moIsLocked) {
    if (context) {
      context.gaMethod(
        {
          ...(offer?.gaContext ?? {}),
          ...context.params,
          gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account},` +
            `${((offer?.expireSec || 0) < 0) ? gaUtils.gaBuyBtnContext.offerExpired : (offer?.isBought ? gaUtils.gaBuyBtnContext.offerBought : gaUtils.gaBuyBtnContext.offerLocked)}`
        }
      )
    }
    return
  }
  if (offer?.isFree) {
    if (context) {
      context.gaMethod(
        {
          ...(offer?.gaContext ?? {}),
          ...context.params,
          gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account},${gaUtils.gaBuyBtnContext.offerFree}`
        }
      )
    }
    buyFree(offer, loadingRefer, context)
    return
  }

  if (offer?.id && offer.gameKey && games[offer.gameKey]?.enableCart && offer.price?.value) {
    const gameCartMap: Record<string | number, number> = useGameStore().gameCartMap(routeGame.value?.gameKey)
    const currentGameCart: Games.Offer[] = useGameStore().gameCart(routeGame.value?.gameKey)
    const canAddToCart = !(
      currentGameCart.length >= useGameStore().cartCapacity ||
      (offer?.id &&
        gameCartMap[offer.id] !== undefined &&
        (!offer?.allowQty ||
          (offer?.allowQty &&
            (offer?.purchaseLimit ?? 0) <= (currentGameCart?.[gameCartMap?.[offer?.id] ?? -1]?.qty ?? 0))))
    )
    if (canAddToCart) {
      addToGameCart(offer)
      const gameCart: Games.Offer[] = useGameStore().gameCart(offer?.gameKey) || []
      gaUtils.gaAddToCart(
        {
          currency: offer?.price?.currency,
          value: offer?.discount?.value || offer?.price?.value || 0,
          items: [
            {
              item_id: String(offer?.id),
              item_name: String(offer?.product || offer?.name),
              index: gameCart?.length || 0,
              quantity: offer?.qty ?? 1,
              price: offer?.discount?.value || offer?.price?.value || 0
            }
          ],
          gs_game: offer?.gameKey,
          gs_route: offer?.gaContext?.gs_route || String(utilsPlugin.getApp()?.$route.name),
          gs_section: offer?.gaContext?.gs_section,
          gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account}`
        }
      )

      if (context) {
        context.gaMethod(
          {
            ...(offer?.gaContext ?? {}),
            ...context.params,
            gs_context: `${isLoggedGoat.value ? gaUtils.gaBuyBtnContext.goat_account : gaUtils.gaBuyBtnContext.game_account},` +
              `${gaUtils.gaBuyBtnContext.showStorePaymentDialog}`
          }
        )
      }
    }

    openCartDrawer(offer?.gameKey, {
      gs_game: offer?.gaContext?.gs_game,
      gs_route: offer?.gaContext?.gs_route,
      gs_section: `${offer?.gaContext?.gs_section},${gaUtils.gaSections.paymentDialog},${gaUtils.gaSections.cart}`
    })
    if (canAddToCart) {
      utilsPlugin.getApp()?.$message({
        type: 'success',
        customClass: 'child-inherit-colors text-green-500 z-999999 -translate-x-1/2',
        message: spaI18n.global.t('gamesUtils.addedToCart'),
        duration: 3000,
        placement: 'top-right'
      })
    } else {
      const t = spaI18n.global.t
      let message = t('gamesUtils.alreadyInCart')
      if (gameCartMap[offer.id] !== undefined) {
        message = t('gamesUtils.alreadyInCartMaxQty')
      } else if (currentGameCart.length >= useGameStore().cartCapacity) {
        message = t('gamesUtils.cartFull', { capacity: useGameStore().cartCapacity })
      }
      utilsPlugin.getApp()?.$notify({
        type: 'warning',
        customClass: 'child-inherit-colors text-orange-500 z-999999 max-w-full',
        message,
        duration: 9000,
        offset: 0
      })
    }
  }
}

function showLogInDialog(clearBuyOffer = false, context: LoginContext) {
  if (clearBuyOffer) {
    buyOffer.value = null
  }
  openLoginDialog(context?.gs_game || null, context)
}

function checkBuildVersion(init = false) {
  const isSsr = import.meta.env.SSR
  const isDev = import.meta.env.DEV
  const host = import.meta.env.VITE_HOST || ''
  if (!isSsr && !isDev) {
    let deployVersion = localStorage?.getItem?.('deploy-version')
    if (deployVersion && deployVersion?.length > 50) {
      deployVersion = ''
      localStorage.setItem?.('deploy-version', deployVersion)
    }

    const axiosInst = axios.create()
    axiosInst.get(`${host}/build.txt`)
      .then((data) => {
        const buildTxt = data?.data
        if (buildTxt && buildTxt?.length < 50) {
          if (!init) {
            if (buildTxt && deployVersion && buildTxt !== deployVersion) {
              utilsPlugin.getApp()?.$notify({
                title: spaI18n.global.t('gamesUtils.newVersionTitle'),
                type: 'warning',
                customClass: 'child-inherit-colors text-orange-400 z-999999 max-w-full',
                dangerouslyUseHTMLString: true,
                message: `<div class="text-left">${spaI18n.global.t('gamesUtils.newVersionMessagePre')} <a class="text-gs-main-color underline cursor-pointer hover:text-orange-600 active:text-orange-500" onclick="location?.reload?.()" >${spaI18n.global.t('gamesUtils.newVersionMessageLink')}</a>.</div>`,
                duration: 58000
              })
            }
          } else {
            localStorage?.setItem?.('deploy-version', buildTxt)
          }
        } else {
          if (Sentry?.getClient()) {
            Sentry.captureException(new Error('not valid buildTxt'), {
              extra: {
                init,
                buildTxt: (buildTxt?.length ? buildTxt?.substring(0, 50) : buildTxt) || '-',
                axios: true,
                msg: 'not valid buildTxt in checkBuildVersion (v1)'
              }
            })
          }
        }
      })
      .catch((error) => {
        if (Sentry?.getClient()) {
          Sentry.captureException(error, {
            extra: {
              init,
              errorData: {
                response: {
                  status: error?.response?.status,
                  data: typeof error?.response?.data === 'string'
                    ? error.response.data.substring(0, 50)
                    : JSON.stringify(error?.response?.data)
                },
                config: {
                  url: error?.config?.url
                },
                code: error?.code,
                message: error?.message
              },
              axios: true,
              msg: 'catch error in checkBuildVersion (v1)'
            }
          })
        }
      })
  }
}

function checkBuyOfferWithApi(loadingRefer: VueRef<string>) {
  if (buyOffer.value?.gameKey && buyOffer.value?.id) {
    getBuyOfferFromApi(buyOffer.value).then((renderedApiBuyOffers) => {
      const { offers, pageOffer: apiBuyOffer } = renderedApiBuyOffers
      if (apiBuyOffer && !apiBuyOffer?.isBought && buyOffer.value?.id === apiBuyOffer?.id) {
        apiBuyOffer.gaContext = buyOffer.value?.gaContext ? { ...buyOffer.value.gaContext } : undefined
        if (buyOffer.value?.price?.value === apiBuyOffer?.price?.value) {
          buyOffer.value = apiBuyOffer
          buy(apiBuyOffer, loadingRefer)
        } else {
          offerDialog.value.offer = apiBuyOffer
          offerDialog.value.visible = true
          showOfferUrl()
        }
        return
      }
      // replace offers
      if (offers.length) {
        for (const offer of offers) {
          if (offer?.repl && offer?.repl === buyOffer.value?.id) {
            offerDialog.value.offer = offer
            offerDialog.value.visible = true
            showOfferUrl()
            buyOffer.value = null
            showError({
              message: spaI18n.global.t('gamesUtils.betterOffer'),
              customClass: 'notify-text-large z-999999',
              title: spaI18n.global.t('gamesUtils.notification')
            })
            return
          }
        }
      }
      if (apiBuyOffer?.isBought) {
        showError({
          message: spaI18n.global.t('gamesUtils.offerAlreadyBought'),
          customClass: 'notify-text-large z-999999',
          title: spaI18n.global.t('gamesUtils.notification')
        })
      } else {
        showError({
          message: spaI18n.global.t('gamesUtils.offerNoLongerAvailable'),
          customClass: 'notify-text-large z-999999',
          title: spaI18n.global.t('gamesUtils.notification')
        })
      }
      buyOffer.value = null
    })
  }
}

function addToGameCart(offer: Games.Offer) {
  useGameStore().addToGameCart(offer)
}

function getGoatApiUrl(endpoint: string) {
  const apiHost = import.meta.env.VITE_GOAT_API
  return `${apiHost}/api/${endpoint}/`
}

function goatDebugCheckTokens() {
  if (!isLoggedGoat.value || (isLoggedGoat.value && localStorage?.getItem('debug_goat') !== 'on')) {
    return false
  }
  const tokens: { [key: string]: Token } = useGameStore().getTokens
  const goatTokenGames = tokens?.[GameKeyEnum.goat]?.games
  const problems: string[] = []
  const gamesLoyalty: Record<string, Games.Loyalty> = {}
  gameOrder.forEach((gameKey) => {
    const gameKeyLoyalty: Games.Lax<Games.Loyalty> = useGameStore().loyaltyFor(gameKey)
    if (gameKeyLoyalty) {
      gamesLoyalty[gameKey] = gameKeyLoyalty
    }
    if (goatTokenGames?.[gameKey] !== undefined) {
      if (tokens?.[gameKey] === undefined) {
        problems.push(`Token game "${gameKey}" not found in alive connected`)
      } else if (String(goatTokenGames?.[gameKey]) !== String(tokens?.[gameKey]?.id)) {
        problems.push(`Token game "${gameKey} ID:${goatTokenGames?.[gameKey]}" is different from alive connected "${gameKey} ID:${tokens?.[gameKey]?.id}"`)
      } else if (gameKeyLoyalty?.id && String(gameKeyLoyalty.id || 0) !== String(goatTokenGames?.[gameKey])) {
        problems.push(`Token game "${gameKey} ID:${goatTokenGames?.[gameKey]}" is different from game storeUser data "${gameKey} ID:${gameKeyLoyalty?.id}"`)
      } else if (gameKeyLoyalty?.id && String(gameKeyLoyalty?.goatId || 0) !== String(tokens?.goat?.id)) {
        problems.push(`GOAT "ID:${tokens?.goat?.id}" is different from game ${gameKey} storeUser.goatId "${gameKeyLoyalty?.goatId}"`)
      }
    } else if (tokens?.[gameKey] !== undefined) {
      if (goatTokenGames?.[gameKey] === undefined) {
        problems.push(`Connected game (api alive) "${gameKey} ID:${tokens?.[gameKey].id}" not found in games of goat token`)
      } else if (gameKeyLoyalty?.id && String(gameKeyLoyalty?.goatId || 0) !== String(tokens?.goat?.id)) {
        problems.push(`GOAT "ID:${tokens?.goat?.id}" is different from game ${gameKey} storeUser.goatId "${gameKeyLoyalty?.goatId}"`)
      }
    }
  })
  if (problems.length) {
    console?.error('GOAT DEBUG - goatDebugCheckTokens', { tokens, goatTokenGames, gameOrder, problems, gamesLoyalty })
    utilsPlugin.getApp()?.$notify?.closeAll()
    utilsPlugin.getApp()?.$notify({
      title: 'GOAT DEBUG - goatDebugCheckTokens',
      type: 'error',
      message: `${problems.join(', ')}. <br> Goat token: ${tokens?.goat?.token}.`,
      duration: 0,
      offset: 0,
      dangerouslyUseHTMLString: true
    })
  }
}

async function goadLoadAliveData() {
  if (isLoggedGoat.value) {
    await apiGet(GameKeyEnum.goat, getGoatApiUrl('logged/alive')).then((response) => {
      if (!isLoggedGoat.value) {
        return false
      }
      if (response?.data?.status === 'ok') {
        const goatData: Token = useGameStore().token(GameKeyEnum.goat) as Token
        if (goatData?.id) {
          if (response?.headers?.token?.length) {
            decodeGoatToken(response.headers.token, goatData.email || '')
          }
        }
        goatDebugCheckTokens()
        if (response?.data?.com !== undefined && useGameStore().token(GameKeyEnum.goat)?.com !== response?.data?.com) {
          setGameToken(GameKeyEnum.goat, {
            ...useGameStore().token(GameKeyEnum.goat),
            com: response.data.com
          } as Token)
        }
        if (response?.data?.omitMinPurchaseMap) {
          omitMinPurchaseMap.value = response?.data?.omitMinPurchaseMap || {}
        }
      }
    }).catch((err) => {
      if (err?.response?.status === 401 || err?.status === 401) {
        logOut(GameKeyEnum.goat, err)
      } else {
        catchError(err)
      }
    })
  } else {
    // session_id (required by GOAT API unlogged/alive) - set by gaUtils after the cookie decision (GA client_id with consent, random otherwise)
    const clientId = gaUtils.getClientId()
    if (!clientId) {
      gaUtils.whenClientId(goadLoadAliveData)
      return
    }
    await apiGet(GameKeyEnum.goat, getGoatApiUrl('unlogged/alive'), { session_id: clientId }, false).then((response) => {
      if (isLoggedGoat.value) {
        return false
      }
      if (response?.data?.omitMinPurchaseMap) {
        omitMinPurchaseMap.value = response?.data?.omitMinPurchaseMap || {}
      }
    }).catch(catchError)
  }
}

function checkGoatHeaderToken(response: AxiosResponse) {
  if (response?.headers?.token?.length) {
    const goatData: Token = useGameStore().token(GameKeyEnum.goat) as Token
    if (goatData?.id) {
      decodeGoatToken(response.headers.token, goatData.email || '')
    }
  }
}

function goatConnectionSkippedGames(skipped: string[]) {
  if (skipped?.length) {
    const gamesNames = skipped.map(idGame => games?.[idGame as Games.GameKeyType]?.name || idGame).join(', ')
    const skippedKey = skipped.length > 1 ? 'gamesUtils.goatConnectionSkippedPlural' : 'gamesUtils.goatConnectionSkippedSingular'
    ElNotification({
      message: `<div class="text-lg">${spaI18n.global.t(skippedKey, { names: gamesNames })}</div>`,
      type: 'warning',
      offset: 100,
      duration: 0,
      customClass: 'right-1/2 translate-x-1/2 notify-text-large absolute md:w-[550px] max-w-full',
      dangerouslyUseHTMLString: true
    })
  }
}

function getRoutePathToGame(gameKey: Games.GameKeyType) {
  return getLocalePath('game-page', { gameID: games?.[gameKey]?.id })
}

function getRoutePathToGameOffer(gameKey: Games.GameKeyType, offerID: string | number) {
  return getLocalePath('game-product-page', { gameID: games[gameKey]?.id, offerID })
}

const gamesUtils = {
  isProd,
  list: games,
  gameOrder,
  gameLoggedOrder,
  listById,
  routeGame,
  routeGameKey,
  isLogged,
  isLoggedGame,
  getGameSettings,
  getGameApi,
  setGameToken,
  getGameToken,
  getGameTokens,
  clearGameTokens,
  catchError,
  showError,
  apiGet,
  apiPost,
  buildDeepLink,
  renderApiOffers,
  sortByIsBought,
  getBuyOfferFromApi,
  setLoyalty,
  gameLoyalty,
  buyOffer,
  buy,
  logOut,
  showLogInDialog,
  triggerApi,
  isVisibleDocument,
  loading,
  checkBuyOfferWithApi,
  addToGameCart,
  checkCart,
  getGoatApiUrl,
  GameKeyEnum,
  catchFormErrors,
  catchNotifyError,
  isLoggedGoat,
  getGoatData,
  isConnectedAllToGoat,
  isSomeConnectedToGoat,
  goadLoadAliveData,
  checkGoatHeaderToken,
  goatDebugCheckTokens,
  goatConnectionSkippedGames,
  goatSpecialOfferType: 'goatSpecial',
  numbersShortHuman,
  showCheckoutCart,
  getRoutePathToGame,
  getRoutePathToGameOffer
}

export { gamesUtils }
